import { render, staticRenderFns } from "./DyestuffText.vue?vue&type=template&id=089e08c8"
import script from "./DyestuffText.vue?vue&type=script&lang=ts"
export * from "./DyestuffText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports